module.exports = __webpack_public_path__ + "static/img/xnyyx.eb4d4a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/xnyyx.png
// module id = PuQ9
// module chunks = 0